import {AfterViewInit, Component, ElementRef, inject, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {ProductsService} from '@services/products/products.service';
import {barColors} from '@services/doctors/colors';
import {listFields} from './fields';

@Component({
  selector: 'app-bar-chart',
  imports: [],
  templateUrl: './bar-chart.component.html',
  standalone: true,
  styleUrl: './bar-chart.component.scss'
})
export class BarChartComponent implements AfterViewInit, OnChanges {
  @Input() country = 'Austria';
  @Input() myGraphData?: any;

  @ViewChild('canvas') canvas?: ElementRef<HTMLCanvasElement>;

  barNumber = 31;
  countryGraphData?: any[];
  countryGraphLength = 0;
  colors = barColors;
  listFields = listFields;
  totalSum = 0;
  totalNumber = 0;
  ctx?: CanvasRenderingContext2D | null = null;

  private productsService = inject(ProductsService);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['myGraphData']) {
      const graphData = changes['myGraphData'].currentValue;
      console.log('------------------------------------- Graph data:', graphData);
      if (graphData && this.ctx) {
        const xSections = this.barNumber;
        const xStep = (800 - 50) / xSections;
        const barWidth = xStep * 0.6;
        const barSpacing = xStep * 0.2;
        const pos = 15;
        let j = 0;
        this.totalSum = 0;
        this.totalNumber = 0;

        // Calculate total sum and total number
        this.listFields.forEach((field: any) => {
          if (graphData[field.name] && Number(graphData[field.name]) > 0) {
            this.totalNumber++;
            this.totalSum += Number(graphData[field.name]);
          }
        });

        let lastY = 410;
        // Draw bars based on the portion
        this.listFields.forEach((field: any) => {
          if (graphData[field.name] && Number(graphData[field.name]) > 0 && this.ctx) {
            const portion = Number(graphData[field.name]) / this.totalSum;
            console.log('Field:', field, 'Data:', graphData[field.name], 'Portion:', portion);
            this.ctx.fillStyle = field.color;
            const x = 50 + pos * xStep + barSpacing;
            const h = portion * 400;
            const y = lastY - h;
            // const y = 410 - area + lastY;
            this.ctx.beginPath();
            this.ctx.fillRect(x, y, barWidth, h);
            this.ctx.stroke();
            console.log('X:', x, 'Y:', y, 'Area:', h);
            j++;
            lastY = y;
          }
        });
      }
    }
  }

  ngAfterViewInit() {
    const canvas = this.canvas?.nativeElement;
    const ctx = canvas?.getContext('2d');
    this.ctx = ctx;

    if (ctx) {
      if (canvas) {
        canvas.height = 420;
        canvas.width = 805;
      }
      // Draw y-axis with markings
      ctx.beginPath();
      ctx.moveTo(50, 10);
      ctx.lineTo(50, 410);
      ctx.stroke();

      const yMarks = [0, 0.25, 0.5, 0.75, 1];
      yMarks.forEach(mark => {
        const y = 410 - mark * 400;
        ctx.moveTo(45, y);
        ctx.lineTo(50, y);
        ctx.stroke();
        ctx.fillText(mark.toString(), 20, y + 3);
      });

      // Draw x-axis with 56 sections
      ctx.beginPath();
      ctx.moveTo(50, 410);
      ctx.lineTo(800, 410);
      ctx.stroke();

      const xSections = this.barNumber;
      const xStep = (800 - 50) / xSections;
      for (let i = 0; i <= xSections; i++) {
        const x = 50 + i * xStep;
        ctx.moveTo(x, 410);
        ctx.lineTo(x, 415);
        ctx.stroke();
      }
      type Taxonomy = keyof typeof barColors;

      this.productsService.fetchCountryGraphData(this.country)
        .subscribe({
          next: (response: any) => {
            this.countryGraphData = response;
            this.countryGraphLength = response.length;

            if (this.countryGraphData) {
              let graphData = this.countryGraphData;
              let k = 0;
              for (let i = 0; i < this.barNumber; i++) {
                let sum = 0;
                let yIndex = 410;
                if (i === 15) {
                  k = 1;
                  console.log('TTT: ', xStep)
                  continue;
                }
                for (let data of graphData) {
                  let num = Number(data[`U${i + 1 - k}`]);
                  if (num > 0) {
                    sum += num;
                    const taxonomy: string = data['Taxonomy'].toString();

                    ctx.fillStyle = this.colors[taxonomy as Taxonomy] || this.randomColor(0.5);

                    ctx.fillRect(50 + i * xStep + xStep * 0.2, yIndex - num * 400, xStep * 0.6, num * 400);
                    yIndex -= num * 400;
                  }
                }
              }
            }
          },
          error: (err: any) => {
            console.error('Error fetching country graph data:', err);
          }
        });
    }
  }

  randomColor(a: number): string {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  //
  // getCountryDataIntoBarGraph(data: any[], id: string): number[] {
  //
  // }

  drawBar(ctx: CanvasRenderingContext2D, n: number, data: number[]) {
    const xSections = this.barNumber;
    const xStep = (800 - 50) / xSections;
    const barWidth = xStep * 0.8;
    const barSpacing = xStep * 0.2;

    for (let i = 0; i < n; i++) {
      const x = 50 + i * xStep + barSpacing;
      const y = 410 - data[i] * 400;
      ctx.fillRect(x, y, barWidth, 410 - y);
    }
  }

}
